import { Text } from '@makemydeal/dr-ui-bricks-components';
import styled from 'styled-components';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';

export const StyledBuyerName = styled(Text)`
    cursor: pointer;
    vertical-align: bottom;
    text-decoration: underline;
    text-decoration-style: solid;
    text-decoration-thickness: 0;
    color: ${({ theme }) => theme.uiBricks?.modalBackgroundColor};

    @media (max-width: ${BreakPoints.PHONE}) {
        display: inline-block;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
    }
`;

// Same DS treatment as the buyer name; size/weight are passed at the call site (Cobuyer.tsx).
export const StyledCobuyerName = StyledBuyerName;

export const StyledInboxAction = styled(Text)`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    vertical-align: bottom;
    color: ${({ theme }) => theme.uiBricks?.modalBackgroundColor};
    text-decoration: underline;

    @media (max-width: ${BreakPoints.PHONE}) {
        white-space: nowrap;
    }
`;

export const StyledAddCoBuyerButton = styled(Text)`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: ${({ theme }) => theme.uiBricks?.modalBackgroundColor};

    @media (max-width: ${BreakPoints.PHONE}) {
        flex-shrink: 0;
        white-space: nowrap;
    }
`;
